var api = "https://api.qingcigame.com";
const config = {
  account: "",
  channel: "",
  id: "",
  platform: "",
  area: "",
  game_id: 69,
  role_id: "",
  page_id: 8,
};
// 绑定信息
let bindParams = {};
// 活动信息
var activity = {};
// 点亮花灯动画次数
var lightenCountNum = 0;
// 是否在点亮中
let isAnimation = false;
let timer = null;
let wait = 60;
var shareText = "";
shareText = [
  "珍绮华筵，蝶舞翩跹。首款Clamp杂志款小小樱限时发售中，点击链接查看",
  "与我一起前往宝石之境，携手梦幻小小樱开启神秘国度之旅。点击链接前往",
  "《魔卡少女樱：回忆钥匙》满月庆典现已开启！首款梦幻小小樱限时发售中，快来参与庆典吧！",
][Math.floor(Math.random() * 3)];
var requestInterface = {};
// 轮播图第一屏角色
var slide1Role = 1;
// 轮播图第二屏角色
var slide2Role = 1;
$(document).ready(function () {
  var isClickNav = false;

  // 导航栏滚动监听
  function scrollToTarget(target, duration) {
    var scrollTopValue = target == "0" ? 0 : $(target).offset().top;
    $("html, body").animate(
      {
        scrollTop: scrollTopValue,
      },
      duration
    );
    setTimeout(function () {
      isClickNav = false;
    }, duration + 100); // 延迟时间稍微多一点，确保动画完成
  }

  // 导航栏点击事件
  $(".nav-link").on("click", function () {
    if (isClickNav) return;
    isClickNav = true;
    var target = $(this).data("target");
    $(".nav-link").removeClass("on1 on2 on3");
    if (target !== "0") {
      if (target === ".content_02") {
        $(this).addClass("on1");
      } else if (target === ".content_03") {
        $(this).addClass("on2");
      } else if (target === ".content_04") {
        $(this).addClass("on3");
      }
    }
    scrollToTarget(target, 500);
  });

  // 监听滚动
  $(window).scroll(function () {
    if (!isClickNav) {
      $(".nav-link").removeClass("on1 on2 on3");
      if ($(document).scrollTop() >= $(".content_04").offset().top) {
        $(".nav3").addClass("on3");
      } else if ($(document).scrollTop() >= $(".content_03").offset().top) {
        $(".nav2").addClass("on2");
      } else if ($(document).scrollTop() >= $(".content_02").offset().top) {
        $(".nav1").addClass("on1");
      }
    }
  });
});
var obj = {
  index: function () {
    $(".index").removeClass("loading");
    $(".slide1 .role1, .slide1 .role2").hide();
    $(".slide1 .role" + slide1Role).show();
    $(".slide1 .icon1, .slide1 .icon2").addClass("gray");
    $(".slide1 .icon" + slide1Role).removeClass("gray");
    $(".slide2 .role")
      .removeClass("role1 role2 role3")
      .addClass("role" + slide2Role);
    $(".slide2 .icon1, .slide2 .icon2, .slide2 .icon3").addClass("gray");
    $(".slide2 .icon" + slide2Role).removeClass("gray");
    this.preloading(); // 预加载
    this.indexSwiper(); // 首页大轮播
    this.indexBind();
    this.loginEventBind(); // 登陆相关绑定事件
    this.onInit();
    this.share();
  },

  // 图片资源预加载
  preloading: function () {
    //图片预加载
    var queue = new createjs.LoadQueue();
    queue.on(
      "progress",
      function (e) {
        //加载中的进度
        if (e.progress * 100 >= 10) {
          $(".loding_time p").text(parseInt(e.progress * 100) + "%");
        }
      },
      this
    );
    queue.on(
      "complete",
      function (e) {
        //加载完成执行操作
        $(".loding_time").remove();
        $(".preloading").addClass("preloading-ani").fadeOut(1000);
        $(".index").removeClass("loading");

        setTimeout(function () {
          $(".preloading").remove();
        }, 1000);
      },
      this
    );
    queue.loadManifest([
      //加载图片，不包括后台的
      "/challengeThirdSeason/images/mobile/1/bg-aa2965bf7a.png",
      "/challengeThirdSeason/images/mobile/2/bg-f0e8c558fe.png",
      "/challengeThirdSeason/images/mobile/2/slide1/role1-c32e4f9776.png",
      "/challengeThirdSeason/images/mobile/2/slide1/role2-055491ab24.png",
      "/challengeThirdSeason/images/mobile/2/slide2/role1-1baace72ac.png",
      "/challengeThirdSeason/images/mobile/2/slide2/role2-3a0dab02d9.png",
      "/challengeThirdSeason/images/mobile/2/slide2/role3-8da9e3889a.png",
      "/challengeThirdSeason/images/mobile/2/slide3/content-ea28d2a1b5.png",
      "/challengeThirdSeason/images/mobile/3/bg-14ff9c1dda.png",
      "/challengeThirdSeason/images/mobile/3/skin-d6f42e63aa.png",
      "/challengeThirdSeason/images/mobile/4/bg-1a3ccd0ca7.png",
      "/challengeThirdSeason/images/mobile/4/task_bg-892791d5f1.png",
    ]);
  },

  // 首页轮播
  indexSwiper: function () {
    var mySwiper1 = new Swiper(".swiper-container2", {
      // initialSlide: 0,
      autoplay: false, //可选选项，自动滑动
      loop: false,
      pagination: ".swiper-pagination",
      paginationClickable: true,
      observer: true,
      observeParents: true,
      autoplayDisableOnInteraction: false,
      onSlideChangeStart: function (swiper) {},
    });
  },

  // 绑定点击事件
  indexBind: function () {
    // 切换轮播图第一屏角色
    $(".slide1 .icon_wrap div").click(function () {
      var target = $(this).data("target");
      slide1Role = target;
      $(".slide1 .role").fadeOut();
      $(".slide1 .role" + target).fadeIn();
      $(".slide1 .icon1, .slide1 .icon2").addClass("gray");
      $(".slide1 .icon" + target).removeClass("gray");
    });

    // 点击显示技能弹窗
    $(".skill").click(function () {
      var skillId = $(this).data("skillid");
      $(".skill_wrap")
        .removeClass()
        .addClass("skill_wrap skill" + skillId);
      $(".skill_dialog").fadeIn();
    });

    // 关闭技能弹窗
    $(".skill_dialog .close").click(function () {
      $(".skill_dialog").fadeOut();
    });

    // 点击显示魂器弹窗
    $(".Horcru").click(function () {
      var HorcruId = $(this).data("id");
      $(".Horcru_wrap")
        .removeClass()
        .addClass("Horcru_wrap Horcru" + HorcruId);
      $(".Horcru_dialog").fadeIn();
    });

    // 关闭魂器弹窗
    $(".Horcru_dialog .close").click(function () {
      $(".Horcru_dialog").fadeOut();
    });

    // 切换轮播图第二屏角色
    $(".slide2 .icon_wrap div").click(function () {
      var target = $(this).data("target");
      slide2Role = target;
      $(".slide2 .role")
        .removeClass("role1 role2 role3")
        .addClass("role" + slide2Role);
      $(".slide2 .icon1, .slide2 .icon2, .slide2 .icon3").addClass("gray");
      $(".slide2 .icon" + slide2Role).removeClass("gray");
    });

    // 打开活动详情
    $(".rule_btn").click(function () {
      $(".detail_dialog").fadeIn();
    });

    // 关闭活动详情
    $(".detail_wrap .close").click(function () {
      $(".detail_dialog").fadeOut();
    });

    // 打开领取详情
    $(".detail_btn").click(function () {
      if (!config.account) {
        return $(".register-popup").fadeIn();
      }
      if (activity.get_record_list.length == 0) {
        return layer.msg("暂无领奖记录", { time: 1500 });
      }
      $(".get_detail_dialog").fadeIn();
    });

    // 关闭领取详情
    $(".get_detail_wrap .close").click(function () {
      $(".get_detail_dialog").fadeOut();
    });

    // 点亮花灯
    $(".lighten_btn").click(function () {
      if (!config.account) {
        return $(".register-popup").fadeIn();
      }
      obj.lightenFun();
    });

    // 领取活动奖励
    $(".get_award").click(function () {
      if (!config.account) {
        return $(".register-popup").fadeIn();
      }
      if (activity.total_dice == 0) {
        return layer.msg("请先点亮花灯", { time: 1500 });
      }
      let isGetReward = activity.reward_list.some(
        (task) => task._get == true && task.is_get == false
      );
      if (!isGetReward && activity.total_dice >= 12) {
        return layer.msg("奖励已全部领完");
      }
      if (!isGetReward) {
        return layer.msg("没有可领取的奖励");
      }
      if (!bindParams.role_id) {
        return obj.serverInfo(config.account);
      }
      $(".secondary_confirmation_dialog .server").text(bindParams.server_name);
      $(".secondary_confirmation_dialog .name").text(bindParams.role_name);
      $(".secondary_confirmation_dialog").show();
    });

    // 领取任务奖励
    $(".get_task").click(function () {
      if (!config.account) {
        return $(".register-popup").fadeIn();
      }
      obj.getLightenNumFun();
    });

    // 任务的去完成
    $(".unfinished").click(function () {
      if (!config.account) {
        return $(".register-popup").fadeIn();
      }
      if ($(this).data("taskid") == 1) {
        return;
      }
      if ($(this).data("taskid") == 2) {
        return $(".share_dialog").show();
      }
      if ($(this).data("taskid") == 3) {
        return (window.location.href = activity.task_info[2].link);
      }
      obj.taskFun($(this).data("taskid"));
    });

    // 关闭分享弹窗
    $(".share_dialog .close-bg,.share_dialog .close_btn").on(
      "click",
      function () {
        $(".share_dialog").fadeOut();
      }
    );

    // 完成任务4
    $(".tips .detail").on("click", function () {
      requestInterface.countNum("S3巅峰联赛活动页_前往赛事详情");
      if (!config.account || activity.task_info[3]._get) {
        window.location.href =
          "https://hjwq.qingcijoy.com/challengeThirdSeason/league_mobile.html";
        return;
      }
      obj.taskFun(4);
    });

    // 复制功能
    var clipboard = new Clipboard(".copy-btn");
    clipboard.on("success", function (e) {
      console.info("Action:", e.action);
      console.info("Text:", e.text);
      console.info("Trigger:", e.trigger);
      if (activity.task_info[1]._get == false) {
        obj.taskFun(2);
      }
      layer.msg("复制链接,快去分享给好友吧~", { time: 2000 });
      e.clearSelection();
      requestInterface.countNum("S3巅峰联赛活动页_复制链接");
    });

    // 领取奖励二次弹窗确认按钮
    $(".secondary_confirmation_dialog .confirm").click(function () {
      obj.rewardFun();
      $(".secondary_confirmation_dialog").hide();
    });

    // 领取奖励二次弹窗取消按钮
    $(
      ".secondary_confirmation_dialog .cancell,.secondary_confirmation_dialog .close"
    ).click(function () {
      bindParams = {};
      $(".secondary_confirmation_dialog").hide();
    });
  },

  // 登陆弹窗相关事件绑定
  loginEventBind: function () {
    // 切换登陆方式
    $(".register-box .title").on("click", "div", function (event) {
      $(this).addClass("active").siblings().removeClass("active");
      for (var i = 0; i <= 2; i++) {
        $(".form-main").removeClass("move-" + i + "");
      }
      $(".form-main").addClass("move-" + $(this).attr("data") + "");
    });
    // 登陆弹窗关闭按钮
    $(".register-popup .close-bg").on("click", function () {
      $(".register-popup").fadeOut();
    });
    // 光子服/正式服 切换
    $(".tab-server").on("click", "div", function (event) {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active")
        .parent(".tab-server")
        .siblings(".option-main")
        .children(".option-box")
        .eq($(this).index())
        .addClass("show")
        .siblings()
        .removeClass("show");

      $(".gzf select").val("0");
      $(".gzf input[name=gzf_role_name]").val("");
      $(".zsf-os").val("");
      $(".zsf-server").val("");
      $(".zsf input[name=zsf_role_name]").val("");

      bindParams = {
        game_id: $(this).parent().find(".active").attr("data-game-id"),
        role_id: "",
        role_name: "",
        server_id: "",
        server_name: "",
        type: "",
      };
    });

    // 账户登陆
    $(".register-btn").click(function (event) {
      const account = $(".inp-account").val();
      const password = $(".inp-password").val();
      if (account == "") {
        layer.msg("请输入您的账号", { time: 2000 });
        return false;
      }
      if (password == "") {
        layer.msg("请输入您的密码", { time: 2000 });
        return false;
      }
      requestInterface.accountLogin(
        { account, password, game_id: 69 },
        function (response) {
          localStorage.setItem("access_token", response.data.uuid);
          $(".popup").fadeOut();
          obj.onInit();
        }
      );
    });
    // 验证码登陆
    $(".sms-login").click(function () {
      const account = $(".phone-inp").val();
      const code = $("input[name=sms_code]").val();

      if (account == "") {
        layer.msg("请输入正确的手机号", { time: 2000 });
        return false;
      }
      if (!code) {
        layer.msg("请输入您的验证码", { time: 2000 });
        return false;
      }

      requestInterface.smsLogin(
        { account, sms_code: code, game_id: 69 },
        function (response) {
          localStorage.setItem("access_token", response.data.uuid);
          $(".popup").fadeOut();
          obj.onInit();
        }
      );
    });

    // 验证码发送
    $(".obtain-verification").on("click", "a", function (event) {
      const phone = $(".phone-inp");
      if (!phone.val()) {
        layer.msg("请输入手机号", { time: 2000 });
        phone.focus();
        return false;
      }
      requestInterface.sendSms(phone.val());
    });

    // 绑定角色
    $(".confirm-btn").click(function (event) {
      console.log(bindParams);
      if (bindParams.role_id == undefined) {
        layer.msg("请先选择信息");
        return false;
      }
      $(".server-popup").fadeOut();
      $(".secondary_confirmation_dialog .server").text(bindParams.server_name);
      $(".secondary_confirmation_dialog .name").text(bindParams.role_name);
      $(".secondary_confirmation_dialog").fadeIn();
    });
    $(".cancell-btn").on("click", function () {
      bindParams = {};
      $(".server-popup").fadeOut();
    });

    $(".channel-cancell-btn").click(function (event) {
      obj.onLogout();
    });

    // 头部点击
    $(".header .login-btn").on("click", function () {
      obj.openLoginPopup();
      requestInterface.countNum("S3巅峰联赛活动页_登陆按钮");
    });
    $(".header .logout-btn").on("click", function () {
      $(".logout-popup").fadeIn();
      requestInterface.countNum("S3巅峰联赛活动页_注销按钮");
    });
    $(".logout-popup .close-bg").on("click", function () {
      $(".logout-popup").fadeOut();
    });
  },

  // 打开登陆弹窗
  openLoginPopup: function () {
    $(".inp-account").val("");
    $(".inp-password").val("");
    $(".phone-inp").val("");
    $("input[name=sms_code]").val("");
    $(".inp-role-name").val("");
    $(".inp-role-id").val("");
    clearTimeout(timer);
    wait = 60;
    setTimeout(() => {
      $(".obtain-verification label span a").remove();
      $(".obtain-verification label span").html("<a>发送</a>");
    }, 100);
    $(".register-popup").fadeIn();
  },

  // 获取角色信息
  serverInfo: function (account) {
    // 初始化打开状态
    $(".tab-server").show();
    $(".tab-server").find(".active").removeClass("active");
    $(".tab-server").find("div:first").addClass("active");
    $(".gzf").addClass("show");
    $(".zsf").removeClass("show");
    $("input[name=gzf_role_name]").val("");
    $("input[name=zsf_role_name]").val("");

    // 初始化参数状态
    bindParams = {};

    requestInterface.getRoleList(
      { account: account, app_id: 69, page_id: config.page_id },
      function (json) {
        var xff = json.data[58],
          zsf = json.data[69];
        if (!xff && !zsf) {
          layer.msg("查无您的角色信息");
          return false;
        } else if (!xff || !zsf) {
          $(".tab-server").hide();
        } else {
          $(".tab-server").show();
        }

        if (xff) {
          $(".gzf select").html('<option value="0">请选择区组</option>');
          var list = xff.android;
          for (var key in list) {
            var value = list[key];
            const jsonExtra = JSON.stringify(value["extra"]);
            $(".gzf select").append(
              '<option data-role_id="' +
                value["role_id"] +
                '" data-role-name="' +
                value["role_name"] +
                '" data-serverId="' +
                value["server_id"] +
                '" data-platform="' +
                value["platform"] +
                '" data-extra=' +
                jsonExtra +
                ' data-server_name="' +
                value["server_name"] +
                '">' +
                value["server_name"] +
                "</option>"
            );
          }

          $(".gzf select")
            .off("change")
            .on("change", function () {
              var option = $(this).find("option:selected");
              console.log("option", option.val());
              if (option.val() && option.val() != "0") {
                // 改值
                $("input[name=gzf_role_name]").val(
                  $(this).find("option:selected").attr("data-role-name")
                );
                bindParams = {
                  game_id: 58,
                  role_id: option.attr("data-role_id"),
                  role_name: option.attr("data-role-name"),
                  server_id: option.attr("data-serverId"),
                  server_name: option.attr("data-server_name"),
                  type: "android",
                  platform: option.attr("data-platform"),
                  extra: option.attr("data-extra"),
                };
              } else {
                // 清空
                $("input[name=gzf_role_name]").val("");
                bindParams = {};
              }
            });
        } else {
          $(".gzf").removeClass("show");
        }

        if (zsf) {
          // 如果没有光子服就显示
          xff ? $(".zsf").removeClass("show") : $(".zsf").addClass("show");

          $(".zsf-server").html('<option value="">请选择区服</option>');
          // 初始化内容
          $(".zsf-os").html('<option value="">请选择手机系统</option>');

          // 拼接手机系统
          for (var key in zsf) {
            $(".zsf-os").append(
              '<option value="' + key + '">ios/安卓</option>'
            );
          }

          // 手机系统选择
          $(".zsf-os")
            .off("change")
            .on("change", function () {
              bindParams = { game_id: 69, type: $(this).val() };
              var role = zsf[$(this).val()];
              // 区服下拉框设置为空
              $(".zsf-server").html('<option value="">请选择区服</option>');
              // 角色信息为空
              $(".zsf-role").val("");
              // 拼接区服下拉框
              for (var key in role) {
                var value = role[key];
                const jsonExtra = JSON.stringify(value["extra"]);
                console.log(jsonExtra);
                $(".zsf-server").append(
                  '<option data-role_id="' +
                    value["role_id"] +
                    '" data-role-name="' +
                    value["role_name"] +
                    '" data-serverId="' +
                    value["server_id"] +
                    '" data-platform="' +
                    value["platform"] +
                    '" data-extra=' +
                    jsonExtra +
                    ' data-server_name="' +
                    value["server_name"] +
                    '">' +
                    value["server_name"] +
                    "</option>"
                );
              }

              // 响应区服下拉框事件
              $(".zsf-server").on("change", function () {
                var option = $(this).find("option:selected");
                if (option.val()) {
                  $(".zsf-role").val(option.attr("data-role-name"));
                  bindParams.role_id = option.attr("data-role_id");
                  bindParams.role_name = option.attr("data-role-name");
                  bindParams.server_id = option.attr("data-serverId");
                  bindParams.server_name = option.attr("data-server_name");
                  (bindParams.platform = option.attr("data-platform")),
                    (bindParams.extra = option.attr("data-extra"));
                } else {
                  $(".zsf-role").val("");
                  bindParams = { game_id: 69, type: $(this).val() };
                }
              });
            });
        } else {
          $(".zsf").removeClass("show");
        }

        $(".inp-account").val(""); // 账号密码清空
        $(".inp-password").val(""); // 账号密码清空
        $(".register-popup").fadeOut(); // 关闭登陆页面
        $(".server-popup").fadeIn(); // 开启服务器
      }
    );
  },

  // 更新头部信息
  updateHeader: function () {
    if (config.account) {
      $(".header .info .name").text(config.account).show();
      $(".header .login-btn, .header .info .game_title").hide();
      $(".header .logout-btn, .header .info .server").show();
    } else {
      $(".header .info .name").text("").hide();
      $(".header .login-btn, .header .info .game_title").show();
      $(".header .logout-btn, .header .info .server").hide();
    }
  },

  // 注销
  onLogout: function () {
    requestInterface.logout(function (json) {
      if (json.code == 200) {
        localStorage.setItem("access_token", "");
        obj.onInit();
        $("#account").html("请先登录");
        $("#server_name").html("");
        $("#role_name").html("");
        config.role_id = "";
        config.account = "";
        bindParams = {};
        activity = {};
        obj.updateHeader();
      }
    });
    $(".popup").fadeOut();
  },

  // 分享
  share: function () {
    var share_icon =
      "https://download4.qcplay.com/qcgame-api/zsRsuUVKbnos6FuBJHK9xTmsCQI6kviEUxd4Bz0c.png";
    var share_title = "战魂共聚，乐享激情";
    var share_min_title =
      "战魂共聚，乐享激情，S3巅峰联赛火热开启中！全新阴阳侠客，精美限定时装邀您一览。参与活动还可获得丰厚游戏奖励";

    outside.share(share_icon, share_title, share_min_title);
  },

  // 初始化用户信息
  onInit: function () {
    requestInterface.init({}, function (response) {
      const { data } = response;
      $(".get_detail_wrap .content").empty();
      if (response.code == 200) {
        const { user_info } = data;
        activity = response.data.activity;
        $.each(activity.get_record_list, function (index, item) {
          $(".get_detail_wrap .content").append(
            `<div class="item">
              <div class="icon${index + 1}-1"></div>
              <div class="icon${index + 1}-2"></div>
              <div class="server">${item.server_name}</div>
              <div class="name">${item.role_name}</div>
              <div class="time">${item.created_at.split(" ")[0]}</div>
            </div>`
          );
        });
        if (isAnimation) {
          obj.lightenAnimation();
        }
        config.account = user_info.account;
      } else {
        obj.openLoginPopup();
      }
      if (activity.total_dice >= 12) {
        $(".lighten3, .lighten7, .lighten9, .lighten12").removeClass("gray");
      } else if (activity.total_dice >= 9) {
        $(".lighten3, .lighten7, .lighten9").removeClass("gray");
      } else if (activity.total_dice >= 7) {
        $(".lighten3, .lighten7").removeClass("gray");
      } else if (activity.total_dice >= 3) {
        $(".lighten3").removeClass("gray");
      } else {
        $(".lighten3, .lighten7, .lighten9, .lighten12").addClass("gray");
      }
      $(".lighten_btn div span").text(activity.total_dice || 0);
      $(".num_bg span").text(activity.dice || 0);
      obj.updateHeader();
      obj.updateLighten();
    });
  },

  // 完成任务
  taskFun: function (id) {
    requestInterface.task({ task_id: id }, function (response) {
      if (response.code == 200) {
        requestInterface.countNum(`S3巅峰联赛活动页_完成任务${id}`);
        if (id == 4) {
          window.location.href =
            "https://hjwq.qingcijoy.com/challengeThirdSeason/league_mobile.html";
        } else if (id == 5) {
          window.location.href = activity.task_info[4].link;
        }
        setTimeout(() => {
          obj.onInit();
        }, 300);
      } else {
        layer.msg(response.message);
      }
    });
  },

  // 更新任务样式
  updateLighten: function () {
    if (config.account) {
      $(".task").each(function () {
        for (let i = 0; i < activity.task_info.length; i++) {
          if ($(this).data("id") == activity.task_info[i].id) {
            if (activity.task_info[i]._get && !activity.task_info[i].is_get) {
              $(this).find(".unfinished, .complete").hide();
              $(this).find(".unclaimed").show();
            } else if (
              activity.task_info[i]._get &&
              activity.task_info[i].is_get
            ) {
              $(this).find(".complete").show();
              $(this).find(".unfinished, .unclaimed").hide();
            } else {
              $(this).find(".unfinished").show();
              $(this).find(".complete, .unclaimed").hide();
            }
          }
        }
      });
    } else {
      $(".task .unfinished").show();
      $(".task .complete, .task .unclaimed").hide();
    }
  },

  // 领取点亮次数
  getLightenNumFun: function () {
    let isGetLightenNum = activity.task_info.some(
      (task) => task._get == true && task.is_get == false
    );
    if (!isGetLightenNum) {
      return layer.msg("没有可领取的奖励");
    }
    requestInterface.getLightenNum({}, function (response) {
      if (response.code == 200) {
        requestInterface.countNum("S3巅峰联赛活动页_领取点亮次数");
        layer.msg("领取成功");
        obj.onInit();
      }
    });
  },

  // 点亮花灯请求
  lightenFun: function () {
    if (activity.dice == 0) {
      return layer.msg("没有点亮次数");
    }
    if (isAnimation) {
      return;
    }
    requestInterface.lighten({}, function (response) {
      if (response.code == 200) {
        requestInterface.countNum("S3巅峰联赛活动页_点亮花灯");
        isAnimation = true;
        obj.onInit();
      }
    });
  },

  // 点亮花灯动画
  lightenAnimation: function () {
    if (lightenCountNum < 3) {
      lightenCountNum += 1;
      // 定义条件和对应的类名
      const conditions = [
        { min: 0, max: 3, className: "lighten3" },
        { min: 3, max: 7, className: "lighten7" },
        { min: 7, max: 9, className: "lighten9" },
        { min: 9, max: 12, className: "lighten12" },
      ];
      // 遍历条件数组并检查条件
      conditions.forEach((condition) => {
        if (
          activity.total_dice > condition.min &&
          activity.total_dice < condition.max
        ) {
          const element = $("." + condition.className);
          element.removeClass("gray");
          setTimeout(() => {
            element.addClass("gray");
          }, 250);
          setTimeout(() => {
            obj.lightenAnimation();
          }, 500);
        } else {
          isAnimation = false;
        }
      });
    } else {
      isAnimation = false;
      lightenCountNum = 0;
    }
  },

  // 领取奖励请求
  rewardFun: function () {
    requestInterface.reward(
      {
        game_id: bindParams.game_id,
        role_id: bindParams.role_id,
        role_name: bindParams.role_name,
        server_id: bindParams.server_id,
        server_name: bindParams.server_name,
        platform: bindParams.platform,
      },
      function (response) {
        if (response.code == 200) {
          requestInterface.countNum(`S3巅峰联赛活动页_领取花灯奖励`);
          layer.msg("领取成功，奖励将通过游戏内邮件发放");
          obj.onInit();
        }
      }
    );
  },
};

// 验证码倒计时
function time() {
  if (wait == 0) {
    $(".obtain-verification label span a").remove();
    $(".obtain-verification label span").html("<a>发送</a>");
    wait = 60;
  } else {
    $(".obtain-verification label span a").remove();
    $(".obtain-verification label span").html("<b>" + wait + "秒</b>");
    wait--;
    timer = setTimeout(function () {
      time();
    }, 1000);
  }
}

requestInterface = {
  accountLogin: function (data, callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/login/account",
      type: "POST",
      xhrFields: { withCredentials: true },
      data,
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  smsLogin: function (data, callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/login/sms",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  sendSms: function (phone) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/snail/login/sms/send",
      type: "POST",
      data: { mobile: phone, channel: "login" },
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        } else {
          // 倒计时
          time();
        }
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  logout: function (callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/game/my/disable",
      type: "POST",
      data: { access_token: localStorage.getItem("access_token") },
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
        } else {
          layer.msg("注销成功");
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  getRoleList: function (data, callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/game/server",
      type: "GET",
      xhrFields: { withCredentials: true },
      data,
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },

  // 业务接口
  init: function (data = {}, callback) {
    data.access_token = localStorage.getItem("access_token") || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/sword/live/index",
      type: "GET",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200 && json.code != 401) {
          layer.msg(json.message);
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  // 完成任务
  task: function (data = {}, callback) {
    data.access_token = localStorage.getItem("access_token") || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/sword/live/task",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  // 领取点亮次数
  getLightenNum: function (data = {}, callback) {
    data.access_token = localStorage.getItem("access_token") || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/sword/live/update",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  // 点亮灯
  lighten: function (data = {}, callback) {
    data.access_token = localStorage.getItem("access_token") || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/sword/live/lottery",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  // 领取游戏奖励
  reward: function (data = {}, callback) {
    data.access_token = localStorage.getItem("access_token") || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/sword/live/reward",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  countNum: function (data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
      } catch (e) {
        console.log(e);
      }
    }, 500);
  },
};
